.ah-root {
    --ah-ink: #0a1f30;
    --ah-muted: #61717d;
    --ah-border: rgba(10,31,48,.14);
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow-x: clip;
    color: var(--ah-ink);
    font-family: inherit;
    line-height: 1.45;
    box-sizing: border-box;
}
.ah-addons-panel {
    display: grid;
    align-content: start;
}
.ah-addons-back {
    display: flex;
    align-items: center;
    gap: 8px;
    width: max-content;
    min-height: 48px;
    margin: -8px 0 11px;
    padding: 0 4px;
    border: 0;
    background: transparent;
    color: var(--ah-primary);
    font-size: 13px;
    font-weight: 800;
}
.ah-addons-back span {
    font-size: 18px;
}
.ah-addons-heading {
    display: grid;
    gap: 5px;
    margin-bottom: 18px;
}
.ah-addons-heading h2 {
    margin: 0;
    font-size: 22px;
    line-height: 1.15;
}
.ah-addons-heading p,.ah-addons-empty {
    margin: 0;
    color: var(--ah-muted);
    font-size: 13px;
}
.ah-addons-grid {
    display: grid;
    gap: 12px;
}
.ah-addon-card {
    display: grid;
    grid-template-columns: 96px minmax(0,1fr) auto;
    align-items: center;
    gap: 16px;
    min-width: 0;
    padding: 14px;
    overflow: hidden;
    border: 1px solid var(--ah-border);
    border-radius: 6px;
    background: #fff;
    transition: border-color .2s ease,box-shadow .2s ease;
}
.ah-addon-card.is-selected {
    border-color: var(--ah-primary);
    box-shadow: 0 0 0 2px color-mix(in srgb,var(--ah-primary) 12%,transparent);
}
.ah-addon-image-button {
    position: relative;
    width: 96px;
    height: 96px;
    padding: 0;
    overflow: hidden;
    border: 1px solid rgba(10,31,48,.12);
    border-radius: 6px;
    background: #fff;
    cursor: zoom-in;
}
.ah-addon-image-button>img {
    display: block;
    width: 100%;
    height: 100%;
    background: #fff;
    object-fit: contain;
    transition: transform .2s ease;
}
.ah-addon-image-button:hover>img {
    transform: scale(1.04);
}
.ah-addon-image-button>span {
    position: absolute;
    right: 5px;
    bottom: 5px;
    display: flex;
    align-items: center;
    gap: 3px;
    min-width: 31px;
    height: 24px;
    padding: 0 6px;
    border-radius: 6px;
    background: rgba(10,31,48,.82);
    color: #fff;
    font-size: 10px;
    font-weight: 800;
}
.ah-addon-image-button svg {
    width: 13px;
    height: 13px;
    fill: none;
    stroke: currentColor;
    stroke-width: 1.8;
}
.ah-addon-image-button:focus-visible {
    outline: 3px solid color-mix(in srgb,var(--ah-primary) 30%,transparent);
    outline-offset: 2px;
}
.ah-addon-copy {
    display: grid;
    gap: 7px;
    min-width: 0;
}
.ah-addon-copy h3 {
    margin: 0;
    font-size: 17px;
    line-height: 1.25;
}
.ah-addon-copy p {
    margin: 0;
    color: var(--ah-muted);
    font-size: 12px;
    line-height: 1.5;
}
.ah-addon-toggle-button {
    min-width: 150px;
    min-height: 50px;
    padding: 0 16px;
    border: 1px solid var(--ah-primary);
    border-radius: 6px;
    background: var(--ah-primary);
    color: #fff;
    font-size: 12px;
    font-weight: 820;
    white-space: nowrap;
}
.ah-addon-toggle-button[aria-pressed="true"] {
    background: color-mix(in srgb,var(--ah-primary) 10%,white);
    color: var(--ah-primary);
}
.ah-addons-empty {
    padding: 20px;
    border: 1px dashed var(--ah-border);
    border-radius: 6px;
    text-align: center;
}
.ah-addon-gallery {
    position: fixed;
    z-index: 500;
    inset: 0;
    display: grid;
    grid-template-rows: auto minmax(0,1fr) auto;
    padding: 0 max(12px,env(safe-area-inset-right)) max(14px,env(safe-area-inset-bottom)) max(12px,env(safe-area-inset-left));
    background: rgba(6,20,30,.96);
    color: #fff;
}
.ah-addon-gallery>header {
    display: grid;
    grid-template-columns: minmax(0,1fr) 48px;
    align-items: center;
    gap: 12px;
    min-height: 72px;
    padding-top: env(safe-area-inset-top);
}
.ah-addon-gallery>header strong {
    overflow: hidden;
    font-size: 16px;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.ah-addon-gallery>header button,.ah-addon-gallery-stage>button {
    display: grid;
    place-items: center;
    width: 48px;
    height: 48px;
    border: 1px solid rgba(255,255,255,.35);
    border-radius: 6px;
    background: rgba(255,255,255,.1);
    color: #fff;
    font-size: 29px;
}
.ah-addon-gallery-stage {
    display: grid;
    grid-template-columns: 48px minmax(0,1fr) 48px;
    align-items: center;
    gap: 10px;
    min-height: 0;
}
.ah-addon-gallery-stage>button:disabled {
    visibility: hidden;
}
.ah-addon-gallery-stage figure {
    display: grid;
    grid-template-rows: minmax(0,1fr) auto;
    justify-items: center;
    align-items: center;
    min-width: 0;
    min-height: 0;
    height: 100%;
    margin: 0;
    padding: 8px 0;
}
.ah-addon-gallery-stage figure img {
    display: block;
    max-width: 100%;
    max-height: calc(100vh - 190px);
    border-radius: 6px;
    background: #fff;
    object-fit: contain;
}
.ah-addon-gallery-stage figcaption {
    padding-top: 8px;
    color: rgba(255,255,255,.76);
    font-size: 12px;
    font-weight: 750;
}
.ah-addon-gallery-thumbnails {
    display: flex;
    justify-content: center;
    gap: 9px;
    max-width: 100%;
    overflow-x: auto;
    padding: 10px 0;
}
.ah-addon-gallery-thumbnails button {
    flex: 0 0 64px;
    width: 64px;
    height: 64px;
    padding: 3px;
    border: 2px solid transparent;
    border-radius: 6px;
    background: rgba(255,255,255,.12);
}
.ah-addon-gallery-thumbnails button.is-active {
    border-color: #fff;
}
.ah-addon-gallery-thumbnails img {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 6px;
    background: #fff;
    object-fit: cover;
}
.ah-root * {
    box-sizing: border-box;
}
.ah-root button,.ah-root input,.ah-root select,.ah-root textarea {
    font: inherit;
}
.ah-shell {
    width: 100%;
    max-width: var(--booking-content-max-width,1130px);
    min-width: 0;
    margin: 0 auto;
    padding: 20px var(--booking-page-gutter,16px) 112px;
}
.ah-eyebrow {
    color: var(--ah-primary);
    font-size: 11px;
    font-weight: 850;
    letter-spacing: .14em;
}
.ah-layout {
    display: grid;
    grid-template-areas: "summary" "main";
    min-width: 0;
    max-width: 100%;
    gap: 18px;
}
.ah-main {
    grid-area: main;
    display: grid;
    max-width: 100%;
    gap: 12px;
    min-width: 0;
}
.ah-panel {
    min-width: 0;
    max-width: 100%;
    background: var(--ah-surface);
    border: 1px solid var(--ah-border);
    border-radius: var(--ah-radius);
    padding: 18px;
    box-shadow: 0 12px 35px rgba(12,39,55,.055);
}
.ah-success h2 {
    font-size: clamp(28px,7vw,42px);
    line-height: 1.06;
    letter-spacing: -.04em;
    margin: 7px 0 8px;
}
.ah-muted {
    color: var(--ah-muted);
    font-size: 13px;
    margin: 0;
}
.ah-section-title {
    margin: 0 0 3px;
    font-size: 17px;
}
.ah-process-trigger {
    display: grid;
    grid-template-columns: auto minmax(0,1fr) 20px;
    align-items: center;
    gap: 10px;
    width: 100%;
    color: var(--ah-ink);
    text-align: left;
    cursor: pointer;
}
.ah-process-trigger .ah-section-title {
    margin: 0;
    font-size: 17px;
    font-weight: 700;
}
.ah-process-trigger>svg,.ah-process-close svg,.ah-process-steps h3 svg {
    width: 20px;
    height: 20px;
    fill: none;
    stroke: var(--ah-primary);
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
}
@media(min-width:700px) and (hover:hover) and (pointer:fine) {
    .ah-process-trigger,.ah-process-dialog .ah-process-close {
        transition: background-color .18s ease,border-color .18s ease;
    }
    .ah-process-trigger>svg:last-child { transition: transform .18s ease; }
    .ah-process-trigger:hover,.ah-process-dialog .ah-process-close:hover {
        background-color: color-mix(in srgb,var(--ah-primary) 4%,white);
        border-color: color-mix(in srgb,var(--ah-primary) 35%,transparent);
    }
    .ah-process-trigger:hover>svg:last-child { transform: translateX(2px); }
}
.ah-process-dialog {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    max-width: none;
    max-height: none;
    margin: 0;
    padding: 0;
    border: 0;
    background: #fff;
    color: var(--ah-ink);
}
.ah-process-dialog[open] {
    display: grid;
    grid-template-rows: auto minmax(0,1fr);
}
.ah-process-dialog::backdrop { background: #fff; }
.ah-process-dialog>header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: calc(12px + env(safe-area-inset-top)) var(--booking-page-gutter,16px) 12px;
    border-bottom: 1px solid var(--ah-border);
}
.ah-process-brand {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
}
.ah-process-brand .ah-process-logo {
    width: 36px;
    height: 36px;
    color: var(--ah-primary);
}
.ah-process-dialog h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    line-height: 1.25;
    letter-spacing: -.025em;
}
.ah-process-dialog .ah-process-close {
    display: inline-flex;
    flex: none;
    align-items: center;
    justify-content: center;
    gap: 5px;
    min-height: 44px;
    padding: 0 10px;
    border: 1px solid var(--ah-border);
    border-radius: 6px;
    background: #fff;
    color: var(--ah-primary);
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
}
.ah-process-content {
    overflow-y: auto;
    overscroll-behavior: contain;
    padding: 8px var(--booking-page-gutter,16px) calc(24px + env(safe-area-inset-bottom));
}
.ah-process-steps {
    max-width: 560px;
    margin: 0 auto;
    padding: 0;
    list-style: none;
}
.ah-process-steps li {
    display: grid;
    grid-template-columns: minmax(0,1fr);
    padding: 18px 0;
}
.ah-process-steps li+li { border-top: 1px solid var(--ah-border); }
.ah-process-steps h3 {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0;
    font-size: 17px;
    font-weight: 700;
    line-height: 1.35;
}
.ah-process-steps h3 svg { flex: none; }
.ah-process-steps p {
    margin: 5px 0 0;
    color: var(--ah-muted);
    font-size: 14px;
    line-height: 1.5;
}
.ah-process-steps .ah-process-highlight {
    /* Extend the card while keeping icons and text aligned with the other steps. */
    margin: 4px -13px;
    padding: 14px 12px;
}
.ah-process-steps .ah-process-highlight+li { border-top: 0; }
@media(min-width:700px) {
    .ah-process-dialog>header {
        width: 100%;
        max-width: 688px;
        margin-inline: auto;
        padding: 20px 24px;
        border-bottom: 0;
    }
    .ah-process-dialog h2 { font-size: 24px; }
    .ah-process-brand .ah-process-logo { width: 40px; height: 40px; }
    .ah-process-dialog .ah-process-close { padding-inline: 12px; font-size: 14px; }
    .ah-process-content { padding: 8px 24px 40px; }
    .ah-process-steps { max-width: 640px; }
    .ah-process-steps li { padding-block: 20px; }
    .ah-process-steps h3 { font-size: 18px; }
    .ah-process-steps p { font-size: 16px; line-height: 1.55; }
    .ah-process-steps .ah-process-highlight { padding-block: 18px; }
}

.ah-section-divider {
    height: 1px;
    background: var(--ah-border);
    margin: 24px 0;
}
.ah-product-picker {
    display: grid;
    gap: 0;
    margin: 0;
    padding: 0;
    border: 0;
}
.ah-postcode-panel .ah-section-title {
    margin: 0 0 12px;
    padding: 0;
    font-size: 17px;
    font-weight: 700;
}
.ah-equipment-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    margin: 0 0 12px;
    padding: 0;
}
.ah-postcode-panel .ah-equipment-heading .ah-section-title {
    flex: none;
    margin: 0;
}
.ah-product-selected {
    display: grid;
    grid-template-columns: 68px minmax(0,1fr) auto;
    align-items: center;
    gap: 12px;
    width: 100%;
    min-height: 84px;
    padding: 8px;
    border: 1px solid var(--ah-border);
    border-radius: 6px;
    background: #fff;
    color: inherit;
    text-align: left;
    box-shadow: 0 2px 8px rgba(12,39,55,.04);
    animation: ah-product-swap .2s ease-out;
}
.ah-product-selected img {
    width: 68px;
    height: 64px;
    border-radius: 6px;
    object-fit: contain;
    background: #fff;
}
.ah-product-selected>span {
    display: grid;
    gap: 3px;
    min-width: 0;
}
.ah-product-selected strong {
    font-size: 14px;
}
.ah-postcode-confirmation,.ah-postcode-error {
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 10px 0 0;
    font-size: 12px;
    line-height: 1.4;
}
.ah-postcode-confirmation {
    width: fit-content;
    max-width: 100%;
    padding: 6px 10px;
    border-radius: 6px;
    background: #e7f7ee;
    color: #087d50;
}
.ah-summary-reassurance,.ah-process-steps .ah-process-highlight,.ah-calendar-price-promise {
    border: 1px solid color-mix(in srgb,var(--ah-primary) 28%,white);
    border-radius: 6px;
    background: linear-gradient(135deg,#e9f8f3,#f1fafc);
    box-shadow: 0 4px 16px rgba(15,76,92,.1),0 0 24px rgba(32,160,139,.08),inset 0 1px 0 rgba(255,255,255,.9);
}
.ah-postcode-error {
    color: #b42318;
}
.ah-postcode-confirmation svg,.ah-postcode-error svg {
    flex: none;
    width: 16px;
    height: 16px;
    fill: none;
    stroke: currentColor;
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
}
@keyframes ah-product-swap {
    from {
        opacity: 0;
        transform: translateY(-4px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
.ah-field {
    display: grid;
    gap: 7px;
    margin-top: 15px;
}
.ah-field>span,.ah-field>label {
    font-size: 13px;
    font-weight: 780;
}
.ah-field>small {
    font-size: 11px;
    color: var(--ah-muted);
}
.ah-field input,.ah-field select,.ah-field textarea,.ah-field .ah-address-trigger {
    width: 100%;
    min-height: 50px;
    border: 1px solid #aeb9c0;
    border-radius: 6px;
    background: #fff;
    color: var(--ah-ink);
    font-size: 16px;
    padding: 0 14px;
    outline: none;
}
.ah-field select {
    padding-right: 40px;
}
.ah-field select:disabled,.ah-field .ah-address-trigger:disabled {
    background: #f5f8f9;
    color: var(--ah-muted);
}
.ah-field textarea {
    min-height: 100px;
    padding-block: 12px;
    resize: vertical;
}
.ah-field input:focus,.ah-field select:focus,.ah-field textarea:focus,.ah-field .ah-address-trigger:focus {
    border-color: var(--ah-primary);
    box-shadow: 0 0 0 3px color-mix(in srgb,var(--ah-primary) 18%,transparent);
}
.ah-details-fields {
    border: 0;
    padding: 0;
    margin: 0;
    min-width: 0;
}
.ah-details-heading,.ah-payment-heading {
    margin-bottom: 15px;
}
.ah-details-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
}
.ah-details-heading .ah-section-title { margin: 0; }
.ah-delivery-updates-chip {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    flex: none;
    padding: 4px 8px;
    border-radius: 6px;
    background: #d9f8e8;
    color: #075e42;
    font-size: 11px;
    font-weight: 650;
    line-height: 1.4;
    white-space: nowrap;
}
.ah-delivery-updates-chip>span { font-size: 12px; line-height: 1; }
@media(max-width:359px) {
    .ah-details-heading { gap: 6px; }
    .ah-details-heading .ah-section-title { font-size: 16px; letter-spacing: -.015em; }
    .ah-delivery-updates-chip { gap: 4px; padding-inline: 5px; font-size: 10px; }
}
.ah-details-heading + .ah-detail-field {
    margin-top: 0;
}
.ah-detail-field.is-invalid input,.ah-detail-field.is-invalid select,.ah-detail-field.is-invalid .ah-address-trigger {
    border-color: #d99d97;
    background: #fffafa;
    box-shadow: 0 0 0 3px rgba(176,67,55,.08);
}
.ah-detail-field.is-invalid input:focus,.ah-detail-field.is-invalid select:focus,.ah-detail-field.is-invalid .ah-address-trigger:focus {
    border-color: #c96f66;
    box-shadow: 0 0 0 3px rgba(176,67,55,.13);
}
.ah-detail-field .ah-field-error {
    color: #a84c43;
}
.ah-detail-field.is-invalid[data-shake="0"] input,.ah-detail-field.is-invalid[data-shake="0"] select,.ah-detail-field.is-invalid[data-shake="0"] .ah-address-trigger {
    animation: ah-field-shake-a .28s ease-out;
}
.ah-detail-field.is-invalid[data-shake="1"] input,.ah-detail-field.is-invalid[data-shake="1"] select,.ah-detail-field.is-invalid[data-shake="1"] .ah-address-trigger {
    animation: ah-field-shake-b .28s ease-out;
}
@keyframes ah-field-shake-a {
    0%,100% {
        transform: translateX(0);
    }
    25% {
        transform: translateX(-3px);
    }
    55% {
        transform: translateX(2px);
    }
    80% {
        transform: translateX(-1px);
    }
}
@keyframes ah-field-shake-b {
    0%,100% {
        transform: translateX(0);
    }
    25% {
        transform: translateX(-3px);
    }
    55% {
        transform: translateX(2px);
    }
    80% {
        transform: translateX(-1px);
    }
}
.ah-details-fields input::placeholder,.ah-field select.ah-address-select.is-placeholder,.ah-field .ah-address-trigger.is-placeholder {
    font-size: 16px;
    color: #757575;
}
.ah-details-fields input::placeholder {
    opacity: 1;
}
.ah-address-select option {
    font-size: 16px;
    color: var(--ah-ink);
}
.ah-address-picker {
    position: relative;
    min-width: 0;
}
.ah-address-select,.ah-address-trigger {
    appearance: none;
    -webkit-appearance: none;
    cursor: pointer;
    transition: border-color .2s ease,background-color .2s ease,box-shadow .2s ease;
}
.ah-field .ah-address-trigger {
    display: flex;
    align-items: center;
    padding-right: 44px;
    text-align: left;
    font-weight: 400;
}
.ah-address-trigger>span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.ah-address-select:disabled,.ah-address-trigger:disabled { cursor: wait; }
.ah-address-chevron {
    position: absolute;
    right: 14px;
    top: 15px;
    width: 20px;
    height: 20px;
    fill: none;
    stroke: var(--ah-primary);
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
    pointer-events: none;
    transition: transform .2s ease;
}
.ah-address-picker.is-open .ah-address-chevron { transform: rotate(180deg); }
.ah-address-menu {
    position: absolute;
    z-index: 90;
    top: calc(100% + 6px);
    left: 0;
    right: 0;
    overflow-y: auto;
    overscroll-behavior: contain;
    padding: 6px;
    border: 1px solid color-mix(in srgb,var(--ah-primary) 25%,white);
    border-radius: 6px;
    background: #fff;
    box-shadow: 0 12px 32px rgba(10,31,48,.14),0 2px 6px rgba(10,31,48,.05);
    scrollbar-width: thin;
    scrollbar-color: color-mix(in srgb,var(--ah-primary) 30%,white) transparent;
    animation: ah-address-menu-in .16s ease-out;
}
.ah-address-menu.is-above { top: auto; bottom: calc(100% + 6px); }
.ah-address-option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-height: 60px;
    padding: 10px 12px;
    border-radius: 6px;
    color: var(--ah-ink);
    cursor: pointer;
    transition: background-color .16s ease,color .16s ease;
}
.ah-address-option+.ah-address-option { margin-top: 3px; }
.ah-address-option>span { display: grid; gap: 3px; min-width: 0; overflow-wrap: anywhere; }
.ah-address-option strong { font-size: 14px; font-weight: 650; }
.ah-address-option small { color: var(--ah-muted); font-size: 12px; }
.ah-address-option[data-active=true] { background: color-mix(in srgb,var(--ah-primary) 8%,white); }
.ah-address-option[aria-selected=true] { background: var(--ah-primary); color: #fff; }
.ah-address-option[aria-selected=true] small { color: #fff; opacity: .85; }
.ah-address-option svg { width: 19px; height: 19px; flex: none; fill: none; stroke: currentColor; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
@media(hover:hover) and (pointer:fine) {
    .ah-address-trigger:not(:disabled):hover { border-color: var(--ah-primary); background: color-mix(in srgb,var(--ah-primary) 2%,white); }
}
@keyframes ah-address-menu-in { from { opacity: 0; } to { opacity: 1; } }
.ah-root .ah-address-manual-toggle {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-height: 44px;
    margin-top: 3px;
    padding: 0;
    border: 0;
    background: transparent;
    color: var(--ah-primary);
    font-size: 12px;
    text-align: left;
}
.ah-address-manual-toggle svg {
    width: 14px;
    height: 14px;
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
}
.ah-address-manual-toggle[aria-expanded="true"] svg { transform: rotate(180deg); }
.ah-address-manual-toggle:focus-visible {
    outline: 2px solid var(--ah-primary);
    outline-offset: 3px;
    border-radius: 3px;
}
.ah-address-manual-toggle:not(:disabled):hover span { text-decoration: underline; }
.ah-address-manual-toggle:disabled { color: var(--ah-muted); cursor: default; }
.ah-address-status {
    margin: 4px 0 0;
    color: var(--ah-muted);
    font-size: 12px;
}
.ah-manual-address {
    display: grid;
}
.ah-manual-address[hidden] { display: none; }
.ah-manual-address>.ah-field:first-child { margin-top: 8px; }
.ah-manual-address-locality {
    display: grid;
    align-items: start;
    grid-template-columns: minmax(0, 1fr) minmax(0, 2fr);
    gap: 14px;
}
.ah-manual-address input[readonly] {
    background: #f5f8f9;
    color: var(--ah-muted);
}
@media(max-width:540px) {
    .ah-manual-address-locality { grid-template-columns: minmax(0, 1fr); gap: 0; }
}
.ah-stepper {
    display: grid;
    grid-template-columns: 44px 44px 44px;
    width: max-content;
}
.ah-stepper button {
    display: grid;
    place-items: center;
    width: 44px;
    height: 44px;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: var(--ah-primary);
}
.ah-stepper button svg {
    transform-origin: center;
    transition: transform .18s ease;
}
@media(hover:hover) and (pointer:fine) {
    .ah-stepper button:not(:disabled) { cursor: pointer; }
    .ah-stepper button:hover:not(:disabled) svg {
        transform: scale(1.2);
    }
}
.ah-stepper button:focus-visible {
    outline: 2px solid var(--ah-primary);
    outline-offset: 2px;
}
.ah-stepper button:disabled {
    opacity: .35;
}
.ah-stepper output {
    display: grid;
    place-items: center;
    font-size: 18px;
    font-weight: 800;
}
.ah-stepper svg,.ah-success-icon svg {
    width: 20px;
    height: 20px;
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
}
.ah-dates-heading {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
}
.ah-dates-heading .ah-section-title {
    margin: 0;
}
.ah-range-fields {
    display: grid;
    grid-template-columns: repeat(2,minmax(0,1fr));
    align-items: stretch;
    gap: 10px;
    margin-bottom: 16px;
}
.ah-range-fields>button {
    cursor: pointer;
    display: grid;
    align-content: start;
    gap: 4px;
    min-width: 0;
    padding: 10px;
    text-align: left;
    border: 1px solid color-mix(in srgb,var(--ah-primary) 45%,white);
    border-radius: 6px;
    background: color-mix(in srgb,var(--ah-primary) 6%,white);
    color: var(--ah-ink);
    transition: background-color .22s ease,color .22s ease,border-color .22s ease;
}
.ah-range-fields>button.is-active {
    border-color: var(--ah-primary);
    background: var(--ah-primary);
    color: #fff;
}
.ah-date-field-label {
    min-height: 27px;
    font-size: 10px;
    line-height: 1.35;
    font-weight: 600;
    letter-spacing: .025em;
    text-transform: uppercase;
}
.ah-range-fields strong {
    font-size: 13px;
    line-height: 1.4;
    font-weight: 600;
}
.ah-calendar-wrap {
    overflow: hidden;
    border-radius: 6px;
    background: color-mix(in srgb,var(--ah-primary) 3%,white);
    padding: 16px;
}
.ah-booking-calendar {
    --rdp-accent-color: var(--ah-primary);
    --rdp-nav-height: 42px;
    --rdp-nav_button-width: 36px;
    --rdp-selected-border: 0;
    --rdp-day-height: 52px;
    --rdp-day-width: 40px;
    --rdp-day_button-height: 52px;
    --rdp-day_button-width: 100%;
    --rdp-day_button-border: 0;
    --rdp-day_button-border-radius: 0;
    --rdp-range_middle-background-color: transparent;
    --rdp-range_start-background: transparent;
    --rdp-range_end-background: transparent;
    --ah-range-fill: color-mix(in srgb,var(--ah-primary) 18%,white);
    width: 100%;
    margin: 0;
}
.ah-booking-calendar .rdp-months {
    max-width: none;
    justify-content: center;
    gap: 18px;
}
/* Keep desktop navigation alongside the individual month captions. */
.ah-booking-calendar[data-nav-layout="around"] .rdp-button_previous,
.ah-booking-calendar[data-nav-layout="around"] .rdp-button_next {
    top: 3px;
    width: 36px;
    height: 36px;
    background: #fff;
    border-radius: 6px;
}
.ah-calendar-desktop { container: hire-calendar / inline-size; }
.ah-calendar-desktop .rdp-month_caption { align-items: center; }
/* Give each month enough room for prices when the summary narrows the form. */
@container hire-calendar (max-width: 540px) {
    .ah-booking-calendar .rdp-months {
        flex-direction: column;
        gap: 22px;
    }
    .ah-booking-calendar[data-nav-layout="around"] .rdp-month { position: static; }
}
.ah-calendar-desktop .rdp-chevron {
    width: 18px;
    height: 18px;
    fill: var(--ah-ink);
}
.ah-booking-calendar .rdp-month {
    flex: 1;
    min-width: 0;
}
.ah-booking-calendar .rdp-month_grid {
    width: 100%;
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 3px 4px;
}
.ah-booking-calendar .rdp-month_caption {
    justify-content: center;
    height: 42px;
    font-size: 16px;
    font-weight: 650;
}
.ah-booking-calendar .rdp-weekday {
    padding: 8px 0 10px;
    font-size: 12px;
    font-weight: 600;
    color: #4d535c;
    opacity: 1;
}
.ah-booking-calendar .rdp-day {
    width: auto;
    padding: 0;
    color: var(--ah-ink);
    background: transparent;
}
.ah-booking-calendar .rdp-day_button {
    width: 100%;
    margin: 0;
    border: 0;
    border-radius: 0;
    font-size: 16px;
    font-weight: 500;
}
.ah-booking-calendar.has-hire-prices .rdp-day_button {
    display: grid;
    grid-template-rows: 20px 14px;
    min-height: 52px;
    align-content: center;
    justify-items: center;
    gap: 3px;
    padding: 4px 0;
    container-type: inline-size;
}
.ah-calendar-day-number { line-height: 20px; }
.ah-calendar-day-price {
    display: inline-flex;
    align-items: center;
    gap: 1px;
    font-size: min(11px,calc((180cqi - 8px) / var(--ah-price-units)));
    font-weight: 600;
    line-height: 14px;
    font-variant-numeric: tabular-nums;
    letter-spacing: -.015em;
    white-space: nowrap;
    color: #365464;
}
.ah-calendar-day-price.is-capped {
    font-size: min(11px,calc((180cqi - 28px) / var(--ah-price-units)));
}
.ah-calendar-price-currency { font-size: .75em; }
.ah-calendar-price-pence {
    font-size: .75em;
    font-weight: 500;
    vertical-align: .15em;
}
.ah-calendar-range-start .ah-calendar-day-price,.ah-calendar-range-end .ah-calendar-day-price { color: inherit; }
.ah-calendar-day-price svg,.ah-calendar-price-promise>svg {
    fill: none;
    stroke: currentColor;
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
}
.ah-calendar-day-price svg {
    width: 9px;
    height: 10px;
    flex: 0 0 9px;
}
.ah-calendar-cutoff .rdp-day_button,.ah-calendar-unavailable .rdp-day_button {
    color: #a4a8b0;
    cursor: not-allowed;
}
.rdp-disabled.ah-calendar-refreshing,
.rdp-disabled.ah-calendar-cutoff,
.rdp-disabled.ah-calendar-unavailable {
    opacity: 1;
}
.ah-calendar-selected .rdp-day_button {
    font-weight: 650;
    color: var(--ah-primary);
}
.ah-booking-calendar .ah-calendar-range-middle .rdp-day_button {
    background: var(--ah-range-fill);
}
.ah-booking-calendar .ah-calendar-range-start .rdp-day_button,.ah-booking-calendar .ah-calendar-range-end .rdp-day_button {
    background: var(--ah-primary);
    color: #fff;
}
.ah-booking-calendar .ah-calendar-range-start .rdp-day_button {
    border-radius: 6px 0 0 6px;
}
.ah-booking-calendar .ah-calendar-range-end .rdp-day_button {
    border-radius: 0 6px 6px 0;
}
.ah-booking-calendar .ah-calendar-range-start.ah-calendar-range-end .rdp-day_button {
    border-radius: 6px;
}
@media(max-width:699px) {
    .ah-range-fields {
        grid-template-rows: auto auto;
        row-gap: 4px;
    }
    .ah-range-fields>button {
        grid-row: span 2;
        grid-template-rows: subgrid;
        min-height: 0;
    }
    .ah-date-field-label { min-height: 0; }
    .ah-range-fields strong { padding-block: 4px; }
}
@media(min-width:700px) {
    .ah-dates-heading { align-items: center; }
    .ah-dates-heading .ah-reset-dates { flex-shrink: 0; }
    .ah-range-fields>button { padding: 12px; }
    .ah-date-field-label { min-height: 14px; }
    .ah-range-fields strong { font-size: 14px; }
}
@media(min-width:700px) and (hover:hover) and (pointer:fine) {
    .ah-calendar-desktop .rdp-day_button {
        transition: transform .18s ease,background-color .18s ease,box-shadow .18s ease,color .18s ease;
    }
    .ah-calendar-desktop :is(.ah-calendar-available,.ah-calendar-range-start) .rdp-day_button:not(:disabled):not([aria-disabled="true"]):hover {
        transform: scale(1.04);
        box-shadow: 0 2px 8px color-mix(in srgb,var(--ah-primary) 14%,transparent);
    }
    .ah-calendar-desktop .ah-calendar-available:not(.ah-calendar-range-start):not(.ah-calendar-range-end) .rdp-day_button:not(:disabled):not([aria-disabled="true"]):hover {
        background: var(--ah-range-fill);
        border-radius: 6px;
    }
    .ah-calendar-desktop .is-previewing .ah-calendar-range-end .rdp-day_button:not(:disabled):not([aria-disabled="true"]):hover {
        transform: none;
        box-shadow: none;
    }
}

.ah-postcode-field {
    position: relative;
    margin-top: 0;
}
.ah-postcode-field input {
    padding-right: 44px;
    border: 2px solid color-mix(in srgb,var(--ah-primary) 55%,white);
    background: color-mix(in srgb,var(--ah-primary) 3%,white);
    box-shadow: 0 2px 10px rgba(15,76,92,.06);
    transition: border-color .18s ease,box-shadow .18s ease;
}
.ah-postcode-spinner {
    position: absolute;
    right: 15px;
    top: 16px;
    width: 18px;
    height: 18px;
    border: 2px solid var(--ah-border);
    border-top-color: var(--ah-primary);
    border-radius: 6px;
    animation: ah-spin .75s linear infinite;
}
.ah-dates-reveal {
    display: grid;
    grid-template-rows: 0fr;
    margin-inline: -3px;
    opacity: 0;
    visibility: hidden;
    transition: grid-template-rows .28s cubic-bezier(.2,.8,.2,1),opacity .2s ease,visibility 0s .28s;
}
.ah-dates-reveal.is-open {
    grid-template-rows: 1fr;
    opacity: 1;
    visibility: visible;
    transition-delay: 0s;
}
.ah-dates-reveal-clip {
    min-height: 0;
    overflow: hidden;
}
.ah-dates-reveal-content {
    padding: 0 3px;
}
.ah-visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
    border: 0;
}
.ah-calendar-feedback {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 16px;
}
.ah-calendar-feedback button {
    flex-shrink: 0;
}
.ah-root .ah-reset-dates {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-height: 44px;
    padding: 8px 0;
    border: 0;
    background: transparent;
    box-shadow: none;
    color: var(--ah-primary);
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
}
.ah-reset-dates svg {
    width: 16px;
    height: 16px;
    flex: none;
    fill: none;
    stroke: currentColor;
    stroke-width: 1.8;
    stroke-linecap: round;
}
@media(min-width:700px) and (hover:hover) and (pointer:fine) {
    .ah-root .ah-reset-dates:not(:disabled):hover {
        background: transparent;
        box-shadow: none;
    }
    .ah-reset-dates:not(:disabled):hover span {
        text-decoration: underline;
        text-underline-offset: 3px;
    }
}
.ah-reset-dates:disabled {
    opacity: .45;
    cursor: default;
}
.ah-date-notice {
    position: fixed;
    z-index: 350;
    top: 78px;
    left: 50%;
    width: max-content;
    max-width: calc(100vw - 32px);
    transform: translateX(-50%);
    padding: 10px 14px;
    border: 1px solid #d7e2e6;
    border-radius: 6px;
    background: #fff;
    color: var(--ah-ink);
    box-shadow: 0 10px 30px rgba(10,31,48,.16);
    font-size: 13px;
    font-weight: 750;
    text-align: center;
    animation: ah-notice-in .2s ease-out;
}
@keyframes ah-notice-in {
    from {
        opacity: 0;
        transform: translate(-50%,-7px);
    }
    to {
        opacity: 1;
        transform: translate(-50%,0);
    }
}
.ah-inline-status {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 14px;
    color: var(--ah-muted);
    font-size: 12px;
}
.ah-inline-status span {
    width: 14px;
    height: 14px;
    border: 2px solid #c7d5da;
    border-top-color: var(--ah-primary);
    border-radius: 6px;
    animation: ah-spin .75s linear infinite;
}
.ah-unavailable {
    display: grid;
    gap: 9px;
    margin-top: 18px;
    padding: 14px;
    border: 1px solid #e3bf78;
    border-radius: 6px;
    background: #fffaf0;
}
.ah-alternatives {
    display: flex;
    gap: 7px;
    flex-wrap: wrap;
}
.ah-alternatives span {
    background: #fff;
    border: 1px solid #dec68f;
    padding: 7px 9px;
    border-radius: 6px;
    font-size: 11px;
}
.ah-stage-action {
    width: 100%;
    margin-top: 22px;
}
.ah-root .ah-primary-button {
    min-height: 52px;
    border: 0;
    border-radius: 6px;
    padding: 0 18px;
    background: var(--ah-primary);
    color: #fff;
    font-weight: 700;
    cursor: pointer;
    transition: background-color .2s ease,box-shadow .2s ease;
}
.ah-primary-button:disabled {
    opacity: .45;
    cursor: not-allowed;
}
.ah-primary-button[aria-busy=true] {
    opacity: 1;
    cursor: progress;
}
@media(hover:hover) and (pointer:fine) {
    .ah-primary-button:not(:disabled):not([aria-busy=true]):hover {
        background: color-mix(in srgb,var(--ah-primary) 90%,black);
        box-shadow: 0 3px 10px color-mix(in srgb,var(--ah-primary) 18%,transparent);
    }
}
.ah-continue-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    line-height: 1.25;
}
.ah-continue-lock,.ah-continue-arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
    width: 20px;
    height: 20px;
}
.ah-continue-content svg {
    width: 20px;
    height: 20px;
    fill: none;
    stroke: currentColor;
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
}
.ah-continue-spinner {
    display: inline-block;
    flex: none;
    width: 18px;
    height: 18px;
    border: 2px solid rgba(255,255,255,.4);
    border-top-color: #fff;
    border-radius: 50%;
    animation: ah-spin .75s linear infinite;
}
.ah-alert {
    margin-top: 14px;
    padding: 13px 14px;
    border-radius: 6px;
    font-size: 13px;
}
.ah-error {
    background: #fff2f0;
    border: 1px solid #efb8ae;
    color: #8a291e;
}
.ah-completed-check {
    display: grid;
    place-items: center;
    width: 28px;
    height: 28px;
    border-radius: 6px;
    background: #eaf8f1;
    color: #116541;
    font-weight: 900;
}
.ah-element-heading button,.ah-text-button {
    min-height: 44px;
    border: 0;
    background: transparent;
    color: var(--ah-primary);
    font-weight: 800;
}
.ah-booking-disclosure {
    overflow: hidden;
    border: 1px solid var(--ah-border);
    border-radius: 6px;
    background: #fff;
}
.ah-booking-disclosure-toggle {
    display: grid;
    grid-template-columns: 40px minmax(0,1fr) 24px;
    align-items: center;
    gap: 11px;
    width: 100%;
    min-height: 70px;
    padding: 12px 16px;
    border: 0;
    background: #fff;
    color: inherit;
    text-align: left;
}
.ah-booking-disclosure-toggle>span:nth-child(2) {
    display: grid;
    min-width: 0;
}
.ah-booking-disclosure-toggle small {
    overflow: hidden;
    color: var(--ah-muted);
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.ah-disclosure-thumbnail {
    position: relative;
    width: 40px;
    height: 40px;
    border: 1px solid var(--ah-border);
    border-radius: 6px;
    background: #fff;
}
.ah-disclosure-thumbnail img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: inherit;
}
.ah-disclosure-thumbnail b {
    position: absolute;
    right: -4px;
    bottom: -4px;
    display: grid;
    place-items: center;
    min-width: 18px;
    height: 18px;
    padding: 0 4px;
    border: 2px solid #fff;
    border-radius: 6px;
    background: var(--ah-primary);
    color: #fff;
    font-size: 10px;
    line-height: 1;
}
.ah-disclosure-caret {
    width: 22px;
    height: 22px;
    fill: none;
    stroke: currentColor;
    stroke-width: 1.8;
    transition: transform .24s cubic-bezier(.2,.8,.2,1);
}
.ah-booking-disclosure.is-open .ah-disclosure-caret {
    transform: rotate(180deg);
}
.ah-booking-disclosure-body {
    display: grid;
    grid-template-rows: 0fr;
    opacity: 0;
    border-top: 1px solid transparent;
    transition: grid-template-rows .28s cubic-bezier(.2,.8,.2,1),opacity .2s ease,border-color .2s ease;
}
.ah-booking-disclosure.is-open .ah-booking-disclosure-body {
    grid-template-rows: 1fr;
    opacity: 1;
    border-top-color: var(--ah-border);
}
.ah-booking-disclosure-inner {
    --ah-summary-section-gap: 16px;
    display: grid;
    gap: var(--ah-summary-section-gap);
    min-height: 0;
    overflow: hidden;
    padding: 0 16px;
    transition: padding .28s cubic-bezier(.2,.8,.2,1);
}
.ah-booking-disclosure.is-open .ah-booking-disclosure-inner {
    padding-block: 16px;
}
.ah-disclosure-details {
    display: grid;
    margin: 0;
    border-top: 1px solid var(--ah-border);
}
.ah-summary-details>div,.ah-summary-costs>div,
.ah-disclosure-details>div,.ah-disclosure-costs>div:not(.ah-disclosure-total) {
    display: grid;
    grid-template-columns: 118px minmax(0,1fr);
    gap: 8px;
    padding: 9px 0;
    border-bottom: 1px solid var(--ah-border);
}
.ah-disclosure-details dt,.ah-disclosure-costs>div:not(.ah-disclosure-total)>span {
    color: var(--ah-muted);
    font-size: 12px;
}
.ah-disclosure-details dd,.ah-disclosure-costs>div:not(.ah-disclosure-total)>strong {
    margin: 0;
    font-size: 12px;
    font-weight: 750;
    text-align: right;
}
.ah-summary-costs,.ah-disclosure-costs {
    display: grid;
    gap: 0;
    margin-top: calc(-1 * var(--ah-summary-section-gap));
}
.ah-disclosure-cost-title {
    padding: 9px 0;
    border-bottom: 1px solid var(--ah-border);
    font-size: 13px;
}
.ah-free-charge {
    color: #13824b;
}
.ah-disclosure-total {
    margin-top: var(--ah-summary-section-gap);
}
.ah-edit-booking-button {
    min-height: 48px;
    border: 1px solid var(--ah-primary);
    border-radius: 6px;
    background: #fff;
    color: var(--ah-primary);
    font-weight: 820;
}
.ah-summary-costs>.ah-addon-cost-row,.ah-disclosure-costs>.ah-addon-cost-row {
    order: 1;
}
.ah-summary-costs>.ah-delivery-cost-row,.ah-disclosure-costs>.ah-delivery-cost-row {
    order: 2;
}
.ah-disclosure-costs>.ah-disclosure-total {
    order: 3;
}
.ah-stripe-address,.ah-payment-element,.ah-express-element {
    position: relative;
    display: block;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    min-height: 0;
    overflow: hidden;
    contain: inline-size;
}
.ah-stripe-address>*,.ah-payment-element>*,.ah-express-element>* {
    width: 100%!important;
    max-width: 100%!important;
    min-width: 0!important;
}
.ah-stripe-address iframe,.ah-payment-element iframe,.ah-express-element iframe {
    display: block;
    width: 100%!important;
    max-width: 100%!important;
    min-width: 0!important;
}
.ah-billing-options {
    display: grid;
    gap: 16px;
}
.ah-billing-checkbox {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding-block: 8px;
    font-size: 14px;
    line-height: 1.5;
    cursor: pointer;
}
.ah-billing-checkbox input {
    flex: none;
    width: 18px;
    height: 18px;
    margin: 1px 0 0;
    accent-color: var(--ah-primary);
    cursor: inherit;
}
.ah-billing-checkbox:has(input:disabled) { cursor: default; opacity: .65; }
.ah-payment-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}
.ah-payment-heading .ah-section-title { margin: 0; }
.ah-payment-security {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    color: var(--ah-primary);
    font-size: 12px;
    font-weight: 600;
    line-height: 1.4;
    white-space: nowrap;
}
.ah-payment-security img {
    display: block;
    flex: none;
    width: auto;
    height: 16px;
}
.ah-payment-security svg {
    flex: none;
    width: 15px;
    height: 15px;
    fill: none;
    stroke: currentColor;
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
}
.ah-payment-section-separator {
    height: 1px;
    margin: 24px 0;
    background: var(--ah-border);
}
.ah-wallet-section {
    margin-bottom: 12px;
    display: grid;
}
.ah-wallet-section[aria-disabled="true"] .ah-express-element {
    opacity: .45;
    pointer-events: none;
}
.ah-wallet-section.is-checking {
    min-height: 52px;
    visibility: hidden;
}
.ah-wallet-section.is-hidden {
    display: none;
    margin-bottom: 0;
}
.ah-desktop-payment-actions {
    display: grid;
    gap: 12px;
    margin-top: 22px;
}
.ah-payment-terms {
    margin: 0;
    color: var(--ah-ink);
    font-size: 13px;
    line-height: 1.4;
}
.ah-payment-terms a {
    color: var(--ah-primary);
    font-weight: 750;
}
.ah-pay-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 9px;
    width: 100%;
    font-size: 16px;
}
.ah-pay-button svg {
    width: 20px;
    height: 20px;
    fill: none;
    stroke: currentColor;
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
}
.ah-sidebar-track {
    grid-area: summary;
    min-width: 0;
}
.ah-summary {
    display: grid;
    align-content: start;
    gap: 16px;
    min-width: 0;
}
.ah-panel.ah-trust-card {
    padding: 16px;
    border-radius: 6px;
}
.ah-trust-link {
    display: block;
    color: inherit;
    text-decoration: none;
    cursor: pointer;
}
.ah-trust-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}
.ah-trust-brand {
    display: flex;
    align-items: center;
    gap: 7px;
}
.ah-trust-brand h3 {
    margin: 0;
    font-size: 15px;
    line-height: 1.2;
    letter-spacing: -.025em;
}
.ah-trust-stars {
    display: flex;
    flex: none;
    order: -1;
    gap: 2px;
}
.ah-trust-star {
    display: block;
    width: 16px;
    height: 16px;
}
.ah-trust-star-background { fill: #dce5e2; }
.ah-trust-star-rating { fill: #00b67a; }
.ah-trust-star-base,.ah-trust-star-fill { fill: #fff; }
.ah-trust-rating {
    display: grid;
    flex: none;
    gap: 2px;
    margin: 0;
    color: var(--ah-ink);
    font-size: 11px;
    text-align: right;
}
.ah-trust-rating strong { font-size: 13px; }
.ah-trust-rating small { color: var(--ah-muted); font-size: 11px; }
.ah-trust-review { display: none; margin: 16px 0; }
.ah-trust-review blockquote {
    margin: 0;
    color: #43545f;
    font-size: 13px;
    font-style: italic;
    line-height: 1.55;
}
.ah-trust-review p { margin: 0 0 7px; }
.ah-trust-review p:first-child::before { content: "“"; }
.ah-trust-review p:last-child::after { content: "”"; }
.ah-trust-review figcaption {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 6px;
    margin-top: 12px;
    color: var(--ah-primary);
    font-size: 12px;
    font-style: normal;
}
.ah-trust-location::before { content: "· "; }
.ah-trust-verified {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-left: auto;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
}
.ah-trust-verified svg {
    width: 14px;
    height: 14px;
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
}
.ah-trust-benefits {
    display: grid;
    grid-template-columns: repeat(3,minmax(0,1fr));
    gap: 8px;
    margin: 14px 0 0;
    padding: 14px 0 0;
    border-top: 1px solid var(--ah-border);
    list-style: none;
}
.ah-trust-benefits li {
    display: grid;
    grid-template-rows: 22px 1fr;
    align-items: center;
    justify-items: center;
    gap: 8px;
    min-width: 0;
    padding: 12px 5px;
    border-radius: 6px;
    background: color-mix(in srgb,var(--ah-primary) 6%,white);
    text-align: center;
}
.ah-trust-benefits svg {
    width: 22px;
    height: 22px;
    fill: none;
    stroke: var(--ah-primary);
    stroke-width: 1.7;
    stroke-linecap: round;
    stroke-linejoin: round;
}
.ah-trust-benefits span {
    font-size: 10px;
    font-weight: 700;
    line-height: 1.3;
    letter-spacing: .025em;
    text-transform: uppercase;
}
@media(min-width:980px) {
    .ah-panel.ah-trust-card { padding: 20px; }
    .ah-trust-brand { gap: 6px; }
    .ah-trust-stars { order: 0; }
    .ah-trust-star { width: 17px; height: 17px; }
    .ah-trust-rated-label { display: none; }
    .ah-trust-rating strong { font-size: 14px; }
    .ah-trust-review { display: block; }
    .ah-trust-benefits { border-top: 0; padding-top: 0; }
}
@media(max-width:979px) {
    .ah-trust-benefits { display: none; }
    .ah-panel.ah-trust-card {
        padding: 0;
        border: 0;
        border-radius: 0;
        background: transparent;
        box-shadow: none;
    }
}
@media(max-width:359px) {
    .ah-trust-heading { gap: 8px; }
    .ah-trust-brand { gap: 5px; }
    .ah-trust-brand h3 { font-size: 13px; }
    .ah-trust-star { width: 14px; height: 14px; }
}
.ah-summary-card {
    --ah-summary-section-gap: 16px;
    display: grid;
    gap: var(--ah-summary-section-gap);
}
.ah-summary-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.ah-summary-title .ah-summary-edit {
    padding: 0;
    border: 0;
    background: transparent;
    color: var(--ah-primary);
    font-size: 13px;
    font-weight: 700;
    line-height: 1.4;
    cursor: pointer;
    text-underline-offset: 3px;
}
@media(hover:hover) and (pointer:fine) {
    .ah-summary-edit:hover { text-decoration: underline; }
}
.ah-summary-reassurance {
    display: grid;
    gap: 12px;
    margin: 0 -12px;
    padding: 14px 12px;
    list-style: none;
    font-size: 12px;
    line-height: 1.5;
}
.ah-summary-reassurance li {
    display: flex;
    align-items: flex-start;
    gap: 10px;
}
.ah-summary-reassurance svg {
    flex: none;
    width: 18px;
    height: 18px;
    color: var(--ah-primary);
    fill: none;
    stroke: currentColor;
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
}
.ah-summary-product {
    display: grid;
    grid-template-columns: 72px 1fr;
    align-items: center;
    gap: 12px;
}
.ah-summary-product img {
    width: 72px;
    height: 72px;
    object-fit: contain;
    border: 1px solid var(--ah-border);
    border-radius: 6px;
    background: #fff;
}
.ah-summary-product h3 {
    font-size: 17px;
    line-height: 1.2;
    margin: 0;
}
.ah-summary-product span {
    color: var(--ah-muted);
    font-size: 12px;
}
.ah-summary-details {
    display: grid;
    margin: 0;
    border-top: 1px solid var(--ah-border);
}
.ah-summary-details dt,.ah-summary-costs>div>span {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: .06em;
    color: var(--ah-muted);
}
.ah-summary-details dd,.ah-summary-costs>div>strong {
    margin: 0;
    font-size: 12px;
    font-weight: 700;
    text-align: right;
}
.ah-total,.ah-disclosure-costs>.ah-disclosure-total {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 18px 16px;
    border-radius: 6px;
    background: color-mix(in srgb,var(--ah-primary) 6%,white);
}
.ah-total {
    margin-inline: -12px;
    padding-inline: 12px;
}
.ah-disclosure-costs>.ah-disclosure-total {
    margin-inline: -8px;
    padding-inline: 8px;
}
.ah-total-copy {
    display: grid;
    gap: 2px;
    min-width: 0;
}
.ah-total-label {
    color: var(--ah-muted);
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .04em;
    line-height: 1.3;
    text-transform: uppercase;
}
.ah-total-note {
    color: var(--ah-primary);
    font-size: 12px;
    font-weight: 500;
    line-height: 1.35;
}
.ah-total>strong,.ah-disclosure-total>strong {
    flex-shrink: 0;
    color: var(--ah-ink);
    font-size: 28px;
    font-weight: 700;
    letter-spacing: -.035em;
    line-height: 1.1;
    text-align: right;
    white-space: nowrap;
}
.ah-skeleton {
    background: #e9eef0;
    border-radius: 6px;
}
.ah-skeleton-price {
    height: 26px;
    width: 60%;
    margin-top: 20px;
}
.ah-booking-loading .ah-mobile-bar .ah-skeleton-price {
    width: 90px;
    height: 20px;
    margin-top: 4px;
}
.ah-booking-loading .ah-range-fields {
    margin-top: 16px;
}
.ah-booking-loading>.ah-muted {
    margin: 0 0 16px;
}
.ah-booking-loading .ah-product-picker {
    margin-bottom: 20px;
}
.ah-loading {
    min-height: 180px;
    display: grid;
    place-content: center;
    justify-items: center;
    gap: 14px;
}
.ah-loading.is-compact {
    min-height: 86px;
}
.ah-loading>span {
    width: 34px;
    height: 34px;
    border: 3px solid color-mix(in srgb,var(--ah-primary) 20%,transparent);
    border-top-color: var(--ah-primary);
    border-radius: 6px;
    animation: ah-spin .75s linear infinite;
}
@keyframes ah-spin {
    to {
        transform: rotate(360deg);
    }
}
.ah-mobile-bar {
    position: fixed;
    z-index: 80;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    max-width: 100vw;
    overflow: hidden;
    display: grid;
    grid-template-columns: minmax(0,1fr) minmax(160px,auto);
    align-items: center;
    gap: 12px;
    padding: 11px var(--booking-page-gutter,16px) calc(11px + env(safe-area-inset-bottom));
    background: rgba(255,255,255,.98);
    backdrop-filter: blur(16px);
    border-top: 1px solid var(--ah-border);
    box-shadow: 0 -8px 30px rgba(10,31,48,.1);
}
.ah-mobile-bar>div {
    min-width: 0;
    display: grid;
}
.ah-mobile-bar small {
    color: var(--ah-muted);
    font-size: 11px;
}
.ah-mobile-bar strong {
    font-size: 16px;
}
.ah-mobile-total {
    align-content: center;
}
.ah-mobile-delivery {
    margin-top: 1px;
}
.ah-mobile-delivery-free {
    color: #13824b;
    font-weight: 750;
}
.ah-mobile-bar .ah-primary-button {
    min-width: 160px;
    padding-inline: 14px;
    font-size: 14px;
}
.ah-mobile-selection-footer {
    grid-template-columns: minmax(0,1fr);
    align-items: stretch;
    gap: 10px;
}
.ah-selection-totals {
    display: grid;
    grid-template-columns: auto minmax(0,1fr);
    align-items: center;
    gap: 12px;
    min-height: 48px;
}
.ah-selection-totals .ah-mobile-total { display: grid; gap: 1px; }
.ah-selection-totals .ah-mobile-total small {
    color: #43545f;
    font-size: 10px;
    font-weight: 650;
    letter-spacing: .055em;
    text-transform: uppercase;
}
.ah-selection-totals .ah-mobile-total strong {
    color: var(--ah-primary);
    font-size: 28px;
    line-height: 1.15;
    font-variant-numeric: tabular-nums;
}
.ah-selection-meta {
    display: grid;
    min-width: 0;
    text-align: right;
    justify-items: end;
    align-content: center;
    gap: 4px;
}
.ah-selection-meta:only-child { grid-column: 1 / -1; }
.ah-selection-meta .ah-mobile-delivery {
    display: flex;
    align-items: center;
    gap: 6px;
    color: var(--ah-primary);
    font-size: 13px;
    font-weight: 600;
}
.ah-selection-meta .ah-mobile-delivery > [aria-hidden="true"] {
    flex: none;
}
.ah-mobile-hire-duration,.ah-mobile-hire-dates { color: var(--ah-muted); font-size: 12px; }
.ah-mobile-hire-dates > span { white-space: nowrap; }
.ah-mobile-selection-footer .ah-primary-button {
    width: 100%;
    min-width: 0;
    min-height: 54px;
    padding-inline: 12px;
    font-size: 15px;
}
@media(max-width:979px) {
    .ah-step-booking.ah-booking-pane-selection .ah-shell { padding-bottom: calc(156px + env(safe-area-inset-bottom)); }
}
@media(max-width:359px) {
    .ah-mobile-selection-footer .ah-primary-button { font-size: 13px; }
}
.ah-mobile-quote-footer {
    row-gap: 9px;
}
.ah-mobile-quote-note {
    grid-column: 1/-1;
    margin: 0;
    color: var(--ah-muted);
    font-size: 11px;
    line-height: 1.35;
}
.ah-mobile-payment-footer {
    grid-template-columns: minmax(0,1fr);
    align-items: stretch;
    gap: 7px;
}
.ah-mobile-payment-footer .ah-selection-totals {
    align-items: start;
}
.ah-mobile-payment-footer .ah-mobile-delivery {
    margin-top: 0;
    align-items: flex-start;
}
.ah-mobile-payment-footer .ah-primary-button {
    width: 100%;
    min-width: 0;
    font-size: 16px;
}
.ah-calendar-modal {
    position: fixed;
    z-index: 200;
    inset: 0;
    display: grid;
    grid-template-rows: auto auto minmax(0,1fr) auto;
    background: #fff;
    color: var(--ah-ink);
}
.ah-calendar-modal>header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: calc(8px + env(safe-area-inset-top)) 16px 8px;
    border-bottom: 1px solid var(--ah-border);
}
.ah-calendar-close {
    width: 44px;
    height: 44px;
    border: 1px solid var(--ah-border);
    border-radius: 6px;
    background: #fff;
    font-size: 22px;
    cursor: pointer;
}
.ah-calendar-modal-fields {
    display: grid;
    padding: 12px 16px;
    border-bottom: 1px solid var(--ah-border);
}
.ah-calendar-modal-fields .ah-range-fields {
    margin: 0;
}
.ah-calendar-price-promise {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-top: 12px;
    padding: 10px 12px;
    color: var(--ah-primary);
}
.ah-dates-reveal-content>.ah-calendar-price-promise { margin: 0 0 16px; }
.ah-calendar-price-promise>svg {
    width: 18px;
    height: 18px;
    flex: 0 0 18px;
}
.ah-calendar-price-promise p {
    display: grid;
    gap: 2px;
    margin: 0;
    font-size: 12px;
    line-height: 17px;
}
.ah-calendar-price-promise strong { font-weight: 750; }
.ah-calendar-scroll {
    overflow-y: auto;
    padding: 12px 12px 100px;
    background: color-mix(in srgb,var(--ah-primary) 3%,white);
}
.ah-calendar-scroll .ah-booking-calendar {
    --rdp-day-height: 52px;
    --rdp-day_button-height: 52px;
}
.ah-calendar-scroll .rdp-months {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 22px;
}
.ah-calendar-scroll .rdp-month {
    width: 100%;
    max-width: 380px;
}

.ah-calendar-modal>footer {
    display: grid;
    padding: 11px var(--booking-page-gutter,16px) calc(11px + env(safe-area-inset-bottom));
    border-top: 1px solid var(--ah-border);
    background: #fff;
    box-shadow: 0 -7px 24px rgba(10,31,48,.09);
}
.ah-calendar-selection-hint {
    margin: 0;
    color: var(--ah-muted);
    font-size: 13px;
    text-align: center;
}
.ah-confirming,.ah-success,.ah-empty {
    max-width: 680px;
    margin: 40px auto;
    text-align: center;
}
.ah-confirming .ah-loading {
    min-height: 130px;
}
.ah-success-icon {
    display: grid;
    place-items: center;
    width: 58px;
    height: 58px;
    border-radius: 6px;
    background: #e6f8ef;
    color: #087444;
    margin: 0 auto 18px;
}
.ah-success p {
    color: var(--ah-muted);
    max-width: 520px;
    margin: 10px auto 24px;
}
.ah-confirmation-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 9px;
    text-align: left;
    margin: 20px 0;
}
.ah-confirmation-grid div {
    background: #f4f7f8;
    border-radius: 6px;
    padding: 11px;
}
.ah-confirmation-grid dt {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: .08em;
    color: var(--ah-muted);
}
.ah-confirmation-grid dd {
    font-weight: 750;
    margin: 3px 0 0;
}
.ah-support-links {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 9px;
    margin-top: 18px;
}
.ah-support-links a {
    display: grid;
    place-items: center;
    min-height: 44px;
    padding: 0 15px;
    border: 1px solid var(--ah-border);
    border-radius: 6px;
    color: inherit;
    font-weight: 750;
    text-decoration: none;
}
@media(min-width:700px) {
    .ah-shell {
        padding-inline: var(--booking-page-gutter,24px);
    }
    .ah-panel {
        padding: 24px;
    }
    .ah-calendar-wrap {
        padding: 16px;
    }
}
@media(max-width:979px) {
    .ah-summary-card {
        display: none;
    }
    .ah-desktop-payment-actions {
        display: none;
    }
    .ah-step-payment .ah-shell {
        padding-bottom: 150px;
    }
}
@media(min-width:980px) {
    .ah-booking-disclosure {
        display: none;
    }
    .ah-shell {
        padding: 30px var(--booking-page-gutter,24px) 60px;
    }
    .ah-layout {
        grid-template-areas: "main summary";
        grid-template-columns: minmax(0,680px) minmax(340px,380px);
        gap: 28px;
        align-items: start;
        justify-content: center;
    }
    .ah-sidebar-track {
        align-self: stretch;
        min-height: var(--ah-sidebar-track-height,0px);
        /* Date edits change these tiles; anchor scrolling to the main form instead. */
        overflow-anchor: none;
    }
    .ah-summary {
        position: sticky;
        top: calc(var(--booking-header-height,71px) + 24px);
    }
    .ah-mobile-bar {
        display: none;
    }
    .ah-panel {
        padding: 28px;
    }
    .ah-stage-panel:not(.ah-postcode-panel) {
        min-height: 630px;
    }
}
@media(max-width:699px) {
    .ah-stage-action {
        display: none;
    }
    .ah-stage-panel {
        border-radius: 6px;
    }
    .ah-product-selected {
        grid-template-columns: 48px minmax(0,1fr) auto;
        gap: 8px;
        min-height: 0;
        /* Add the outline around the existing content width on small screens. */
        width: calc(100% + 16px);
        margin-inline: -8px;
        padding: 6px;
    }
    .ah-product-picker + .ah-section-divider {
        margin-top: 12px;
    }
    .ah-booking-loading .ah-product-picker {
        margin-bottom: 0;
    }
    .ah-product-selected .ah-stepper {
        grid-template-columns: 44px 24px 44px;
    }
    .ah-product-selected img {
        width: 48px;
        height: 58px;
    }
    .ah-booking-disclosure-toggle {
        padding-inline: 12px;
    }
    .ah-booking-disclosure-inner {
        padding-inline: 12px;
    }
    .ah-payment-panel {
        padding-bottom: 20px;
    }
    .ah-customer-details-list div {
        display: grid;
        gap: 3px;
    }
    .ah-customer-details-list dd {
        max-width: none;
        text-align: left;
    }
    .ah-addons-heading h2 {
        font-size: 20px;
    }
    .ah-addon-card {
        grid-template-columns: 82px minmax(0,1fr);
        gap: 12px;
        padding: 12px;
    }
    .ah-addon-image-button {
        width: 82px;
        height: 82px;
    }
    .ah-addon-copy h3 {
        font-size: 15px;
    }
    .ah-addon-toggle-button {
        grid-column: 1/-1;
        width: 100%;
        min-width: 0;
    }
}
@media(max-width:359px) {
    .ah-step-payment .ah-payment-panel {
        padding-inline: 12px;
    }
}
@media(max-width:359px) {
    .ah-addon-gallery-stage {
        grid-template-columns: 40px minmax(0,1fr) 40px;
        gap: 5px;
    }
    .ah-addon-gallery-stage>button {
        width: 40px;
        height: 48px;
    }
    .ah-addon-gallery-stage figure img {
        max-height: calc(100vh - 205px);
    }
}
@media(max-width:359px) {
    .ah-product-selected {
        grid-template-columns: 28px minmax(0,1fr) auto;
        gap: 4px;
    }
    .ah-product-selected img {
        width: 28px;
    }
}
@media(prefers-reduced-motion:reduce) {
    .ah-root * {
        scroll-behavior: auto!important;
        animation-duration: .001ms!important;
        transition-duration: .001ms!important;
    }
}

/* Only shown for dehumidifier districts requiring a delivery enquiry. */
.ah-delivery-contact {
    margin-top: 20px;
    padding: 24px;
    border: 1px solid #c8dedb;
    border-radius: 6px;
    background: #f2f8f7;
}
.ah-delivery-contact-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    margin-bottom: 16px;
    border-radius: 50%;
    background: #dceeea;
    color: var(--ah-primary);
}
.ah-delivery-contact svg {
    width: 20px;
    height: 20px;
    flex: none;
    fill: none;
    stroke: currentColor;
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
}
.ah-delivery-contact h3 { margin: 0 0 10px; font-size: 21px; line-height: 1.25; }
.ah-delivery-contact p { margin: 0; font-size: 14px; line-height: 1.6; color: #435c65; }
.ah-delivery-contact p strong { color: var(--ah-ink); white-space: nowrap; }
.ah-delivery-contact-actions { display: flex; gap: 10px; margin-top: 22px; }
.ah-delivery-contact-actions a {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    flex: 1;
    min-height: 48px;
    text-decoration: none;
    font-size: 14px;
}
.ah-delivery-contact-actions .ah-secondary-button {
    border: 1px solid #b8cecb;
    border-radius: 6px;
    background: #fff;
    color: var(--ah-primary);
    font-weight: 700;
}
.ah-delivery-contact-actions .ah-secondary-button:hover { background: #e7f2ef; }
@media (max-width: 640px) {
    .ah-delivery-contact { padding: 20px 16px; }
    .ah-delivery-contact h3 { font-size: 19px; }
    .ah-delivery-contact-actions { flex-direction: column; }
}
